import axios from 'axios'
import router from '../router'


const api = {
	init: function(store) {

		// INTERCEPTEUR DE REQUETE (avant l'appel)
		axios.interceptors.request.use(function (config) {
			// console.log("axios interceptor", config);
			// On ajoute le token uniquement si c'est une requête vers l'api adequation
			const url = config.url
			if (url.startsWith(process.env.VUE_APP_API_BASE_URL) || url.startsWith(process.env.VUE_APP_NEW_API_BASE_URL)) {
				config.headers['Authorization'] = `Bearer ${store.getters.token}`;
			}
			store.dispatch('set_loading', { loading: true })
			return config;
		}, function (error) {
			return Promise.reject(error);
		});

		// INTERCEPTEUR DE REPONSE (après l'appel)
		axios.interceptors.response.use(function (response) {
			store.dispatch('set_loading', { loading: false })
			const url = response.config.url
			if (url.startsWith(process.env.VUE_APP_API_BASE_URL) || url.startsWith(process.env.VUE_APP_NEW_API_BASE_URL)) {
				if (response.status != 200) {
					if (response.data.message) store.dispatch('add_notification', { status: 'error', message: response.data.message })
					else store.dispatch('add_notification', { status: 'error', message: "Oups ! Une erreur est survenue. Format de réponse invalide." })
				}
			}
			return response;
		}, function (error) {
			if (axios.isCancel(error)) return Promise.reject(error);
			const url = error.config.url
			if (url.startsWith(process.env.VUE_APP_API_BASE_URL) || url.startsWith(process.env.VUE_APP_NEW_API_BASE_URL)) {
				if(error.response.status == 401) {
					router.push({name:'login'})
				}
			}
			store.dispatch('add_notification', { status: 'error', message: "Oups ! Impossible de se connecter au serveur." })
			store.dispatch('set_loading', { loading: false })
			// store.dispatch('set_ready', { ready: 'error' })
			return Promise.reject(error);
		});


	}
}

export default api